import { axios } from '../utils/request'

function getAction(url, param) {
    return axios({
        url:url,
        method: 'get',
        params: param
    })
}
function postAction(url, param) {
    return axios({
        url:url,
        method: 'post',
        data: param
    })
}
function putAction(url, param) {
    return axios({
        url:url,
        method: 'put',
        data: param
    })
}
export default {
    getAction,postAction,putAction,
}